import { calcScoreTema, nv } from '@shared/scores.js';
import type { ForcaDef } from './index.js';

type Props = {
  forca: ForcaDef;
  fi: number;
  score: number;
  flat: number[];
};

export function DetalheForca({ forca, fi, score, flat }: Props) {
  const nivel = nv(score);
  const textoNivel = forca.niveis[nivel];
  const prioridades = forca.prio[nivel];
  const t0 = calcScoreTema(flat, fi, 0);
  const t1 = calcScoreTema(flat, fi, 1);

  return (
    <section className="mb-4 border border-ha-border bg-ha-card2" style={{ borderLeftWidth: 4, borderLeftColor: forca.hex }}>
      <header className="border-b border-ha-border px-4 py-3">
        <span className="text-[9px] font-extrabold uppercase tracking-[2px]" style={{ color: forca.texto }}>
          {forca.icone} {forca.num} · {forca.nome}
        </span>
        <p className="mt-1 text-xl font-black" style={{ color: forca.texto }}>
          {score.toFixed(1).replace('.', ',')} <span className="text-sm text-ha-muted">/10</span>
        </p>
        <p className="mt-2 text-xs text-ha-subtle">{textoNivel}</p>
      </header>
      <div className="grid gap-0 border-b border-ha-border sm:grid-cols-2">
        {forca.temas.map((t, ti) => (
          <div key={t.nome} className="border-ha-border px-4 py-3 sm:border-r last:sm:border-r-0">
            <p className="text-[9px] font-bold uppercase text-ha-muted">Tema {ti === 0 ? 'A' : 'B'} · {t.nome}</p>
            <p className="text-lg font-black" style={{ color: forca.texto }}>
              {(ti === 0 ? t0 : t1).toFixed(1).replace('.', ',')}
            </p>
          </div>
        ))}
      </div>
      <div className="px-4 py-3">
        <p className="mb-2 text-[9px] font-extrabold uppercase tracking-[2px] text-ha-muted">Prioridades</p>
        <ul className="space-y-1.5 text-xs text-ha-subtle">
          {prioridades.map((p) => (
            <li key={p} className="flex gap-2">
              <span style={{ color: forca.texto }}>→</span>
              {p}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
